<template>
    <v-modal-slot id="upload-files-expedient-modal"
                  @accepted="attachFilesToExpedient">
        <template v-slot:modal-title>
            Documentos adjuntos al expediente
        </template>

        <template v-slot:modal-content>
            <div class="row">
                <div class="col-12">
                    <files-expedient ref="uploader"></files-expedient>
                </div>
            </div>
        </template>

        <template v-slot:accept-button>
            Guardar
        </template>

        <template v-slot:close-button>
            Cerrar
        </template>

    </v-modal-slot>
</template>

<script>
import FilesExpedient from "../FilesExpedient";
import VModalSlot from "../../../general/VModalSlot";
import {attachFileToExpedientByUuid} from "../../../../helpers/requests/RequestsMedia";

export default {
    name: "ExpedientDetailUploadFilesModal",
    components: {VModalSlot, FilesExpedient},
    props: {
        expedient: {
            type: Object,
            required: true,
        }
    },
    methods: {
        /**
         * Attaches all temporary uploaded files to the provided expedient.
         *
         * @returns {Promise<void>}
         */
        async attachFilesToExpedient() {
            let files = this.$refs.uploader.files;

            for (let i in files) {
                let file = files[i];

                await attachFileToExpedientByUuid(this.expedient.id, file.attributes.uuid);
            }

            this.$emit('files-uploaded');
        },
    },
}
</script>
